import { createStore } from 'vuex'
import Description from './Meta/Description'
import Kodik from './API/Kodik.js'
import Media from './API/Media.js'
import Loading from './UI/Loading.js'
import Library from './Library.js'
import WorthWatching from './WorthWatching.js'

export default createStore({
  modules: { Description, Kodik, Media, Loading, Library, WorthWatching }
})
